import styles from "./ImageShow.module.css";
import Modal from "./Modal";
import tempImage from "../../assets/tempIMG2.jpg";
import { useContext, useEffect, useState } from "react";
import arrow from "../../assets/arrow.png";
import NavigationContext from "../store/navigation-context";
import exit from "../../assets/x-background.png";

export default function ImageShow() {
  const navCtx = useContext(NavigationContext);

  const [currentIndex, setCurretIndex] = useState(navCtx.showImages.key);
  const [nextIndex, setNextIndex] = useState(navCtx.showImages.key);

  // IMAGE ACTIONS ??? WHAT DO?
  /*useEffect(() => {
    if (
      navCtx.showImages.images.length >= 2 &&
      navCtx.showImages.images[0] === navCtx.showImages.images[1]
    ) {
      navCtx.showImages.images = navCtx.showImages.images.shift();
    }
  }, [navCtx.showImages.images]);*/

  const prevImage = () => {
    if (currentIndex > 0) {
      setNextIndex((prevVal) => prevVal - 1);
      setTimeout(() => {
        setCurretIndex((prevVal) => prevVal - 1);
      }, [300]);
    } else {
      setNextIndex(navCtx.showImages.images.length - 1);
      setTimeout(() => {
        setCurretIndex(navCtx.showImages.images.length - 1);
      }, [300]);
    }
  };

  const nextImage = () => {
    if (currentIndex < navCtx.showImages.images.length - 1) {
      setNextIndex((prevVal) => prevVal + 1);
      setTimeout(() => {
        setCurretIndex((prevVal) => prevVal + 1);
      }, [300]);
    } else {
      setNextIndex(0);
      setTimeout(() => {
        setCurretIndex(0);
      }, [300]);
    }
  };

  return (
    <>
      <img
        src={arrow}
        alt="Arrow."
        className={`${styles[`left-arrow`]} ${styles[`arrow`]}`}
        onClick={nextIndex === currentIndex ? prevImage : () => {}}
      />

      <img
        src={arrow}
        alt="Arrow."
        className={styles[`arrow`]}
        onClick={nextIndex === currentIndex ? nextImage : () => {}}
      />

      <img
        src={exit}
        alt="X"
        className={styles.exit}
        onClick={() => {
          navCtx.setShowImages((prevVal) => {
            return {
              state: false,
              images: prevVal.images,
              key: 0,
            };
          });
        }}
      />

      <div className={styles.counter}>
        {currentIndex + 1}/{navCtx.showImages.images.length}
      </div>

      <Modal
        onClose={() => {
          navCtx.setShowImages((prevVal) => {
            return {
              state: false,
              images: prevVal.images,
              key: 0,
            };
          });
        }}
      >
        <main className={styles.main}>
          <div
            className={`${styles[`image-container`]} ${
              styles[currentIndex !== nextIndex && `image-transition`]
            }`}
          >
            <img
              src={navCtx.showImages.images[currentIndex]}
              alt="Image."
              className={`${styles.image}`}
            />
          </div>
        </main>
      </Modal>
    </>
  );
}
